import React from 'react';
import ReactDOM from 'react-dom';
import {createBrowserRouter, createRoutesFromElements, Route, RouterProvider} from "react-router-dom";

import ReactGA from 'react-ga';

import Bugsnag from '@bugsnag/js';
import BugsnagReact from '@bugsnag/plugin-react';

import Auth from './Auth';
import Alert from "./components/Alert";
import Modal from "./components/Modal";
import Navigation from './config/navigation';
import Component from './components/Component';
import ScrollToTop from './components/ScrollToTop';
import TopNavBar from './components/nav/TopNavBar';
import {Slide, ToastContainer} from "react-toastify";
import {QueryClient, QueryClientProvider} from '@tanstack/react-query';
import AuthProvider, {AuthMiddleware} from "./providers/AuthProvider";
import AuthLoading from "./views/auth/Loading";
import ComponentError from "./components/errors/ComponentError";

ReactGA.initialize(laravel.config.GOOGLE_ANALYTICS_TRACKING_ID, {
    // debug: true,
});

class App extends Component {
    static events = {
        'Alert@show': (component, alert) => {
            component.alertRef.setAlert(alert);
        },
        'Alert@hide': (component, alert) => {
            component.alertRef.closeAlert();
        },

        'Modal@show': (component, modalProps) => {
            component.modalRef.showModal(modalProps);
        },
        'Modal@scroll': (component) => {
            component.modalRef.scrollTop();
        },
        'Modal@hide': (component, args) => {
            component.modalRef.hideModal(args);
        },
    };

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            auth: Auth,
            alert: null,
            pages: Navigation.appRoutes()
        };
    }

    async componentDidMount() {
        super.componentDidMount();

        let previousVersion = localStorage?.getItem('app_version');

        if (!previousVersion || previousVersion !== process.env.APP_VERSION) {
            TB.forceClearLocalStorage();

            localStorage.setItem('app_version', process.env.APP_VERSION)
        }
    }

    render() {
        let {pages, hideNavbar} = this.state;

        return (
            <div>

                <RouterProvider router={
                    createBrowserRouter(
                        createRoutesFromElements(
                            <Route errorElement={<ComponentError/>} element={(
                                <AuthProvider>

                                    <AuthMiddleware>
                                        <ScrollToTop/>
                                        <TopNavBar/>
                                        <AuthLoading/>
                                        <Modal ref={modalRef => this.modalRef = modalRef}/>

                                        <Alert ref={alertRef => this.alertRef = alertRef}/>
                                    </AuthMiddleware>

                                </AuthProvider>
                            )}>
                                {pages}
                            </Route>
                        )
                    )
                }>



                </RouterProvider>
                <ToastContainer
                    position="top-center"
                    draggable={false}
                    autoClose={Alert.CLEAR_NOTIFICATION_TIMEOUT}
                    transition={Slide}
                    hideProgressBar={true}
                    closeOnClick
                    pauseOnFocusLoss
                    pauseOnHover
                />

            </div>
        )
    }
}


// console.log('bugsnag', {
//  apiKey: process.env.BUGSNAG_API_KEY,
//  appVersion: process.env.APP_VERSION,
//  notifyReleaseStages: [ 'production', 'staging', 'demo' ],
//  releaseStage: process.env.APP_ENV,
// });


let container = (
    <App/>
)
if (process.env.APP_ENV !== 'local'
    && process.env.BUGSNAG_API_KEY) {
    const BugsnagClient = Bugsnag({
        apiKey: process.env.BUGSNAG_API_KEY,
        appVersion: process.env.APP_VERSION,
        notifyReleaseStages: ['production', 'staging', 'demo', 'demo2'],
        releaseStage: process.env.APP_ENV
    });

    BugsnagClient.use(BugsnagReact, React);

    const BugsnagErrorBoundary = BugsnagClient.getPlugin('react');

    TB.BugsnagClient = BugsnagClient;
    container = (
        <BugsnagErrorBoundary>
            <App/>
        </BugsnagErrorBoundary>
    )
}

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
        },
    },
});
TB.queryClient = queryClient;
// MessageBox component
ReactDOM.render(
    <QueryClientProvider client={queryClient}>
        {container}
        {/*<ReactQueryDevtools initialIsOpen={false} />*/}
    </QueryClientProvider>,
    document.getElementById('app')
);
// <ConfigProvider
//     theme={{
//         token: {
//
//             colorError: TB.config('color.danger'),
//             colorInfo: TB.config('color.info'),
//             colorLink: TB.config('color.info'),
//             colorPrimary: TB.config('color.secondary'),
//             colorSuccess: TB.config('color.success'),
//             colorTextBase: '#000',
//             colorWarning: TB.config('color.warning'),
//             fontFamily: "Beatrice, sans-serif",
//             fontSize: 14,
//             fontSizeSM: 11
//         },
//     }}
//
// >